import React, { Component } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Footer } from "@sunwing/components";
import commonUtilities from "utilities/common";
import "./appFooter.css";

const AppFooter = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const auth = authState?.isAuthenticated;
    const language = commonUtilities.getLanguage();

    if (auth) {

        return (
            <div className="application-footer font-size-14">

                {language === "en" ?
                    <Footer
                        data-testid="app-footer"
                        columns={
                            [
                                {
                                    id: "0",
                                    title: "Vacation deals",
                                    links: [
                                        {
                                            id: "f0-item-0",
                                            title: "Last minute vacations",
                                            url: "https://www.sunwing.ca/en/promotion/packages/last-minute-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-1",
                                            title: "All inclusive vacation packages",
                                            url: "https://www.sunwing.ca/en/promotion/packages/all-inclusive-vacation-packages",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-2",
                                            title: "Staff picks",
                                            url: "https://www.sunwing.ca/en/vacation-packages/deals/staff-picks",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-3",
                                            title: "Hot hotels",
                                            url: "https://www.sunwing.ca/en/promotion/packages/hot-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-4",
                                            title: "Cuba under $999",
                                            url: "https://www.sunwing.ca/en/all-inclusive-cuba-vacations-under-1000-dollars",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-5",
                                            title: "Cancun Is Calling",
                                            url: "https://www.sunwing.ca/en/promotion/packages/cancun-is-calling",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "1",
                                    title: "Sunwing collections",
                                    "links": [
                                        {
                                            id: "f1-item-0",
                                            title: "Sunwing Exclusives",
                                            url: "https://www.sunwing.ca/en/promotion/packages/exclusives",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-1",
                                            title: "Viva Fit",
                                            url: "https://www.sunwing.ca/en/promotion/packages/viva-fit",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-2",
                                            title: "Sunwing favourites",
                                            url: "https://www.sunwing.ca/en/promotion/packages/sunwing-favourites",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-3",
                                            title: "Top-rated adult resorts",
                                            url: "https://www.sunwing.ca/en/promotion/packages/adult-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-4",
                                            title: "Top-rated luxury resorts",
                                            url: "https://www.sunwing.ca/en/promotion/packages/luxury-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-5",
                                            title: "Top-rated family resorts",
                                            url: "https://sunwing.ca/en/promotion/packages/family-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-6",
                                            title: "Smile Resorts - Kids stay FREE",
                                            url: "https://www.sunwing.ca/en/promotion/packages/smile-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-7",
                                            title: "Boutique hotels",
                                            url: "https://www.sunwing.ca/en/promotion/packages/boutique-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-8",
                                            title: "Splashworld",
                                            url: "https://www.sunwing.ca/en/promotion/packages/splashworld-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-9",
                                            title: "Families of 5",
                                            url: "https://www.sunwing.ca/en/best-vacations/best-all-inclusive-resorts-for-families",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-10",
                                            title: "RIU-topia",
                                            url: "https://www.sunwing.ca/en/promotion/packages/riu-topia",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-11",
                                            title: "Spicy collection",
                                            url: "https://www.sunwing.ca/en/promotion/packages/clothing-optional-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-12",
                                            title: "Vacays welcome to everyone under the sun",
                                            url: "https://www.sunwing.ca/en/promotion/packages/2slgbtq-friendly-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-13",
                                            title: "Eco-friendly collection",
                                            url: "https://www.sunwing.ca/en/promotion/packages/eco-friendly-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-14",
                                            title: "As Seen on Reality TV Collection",
                                            url: "https://www.sunwing.ca/en/promotion/packages/reality-tv-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-15",
                                            title: "Best of the Best",
                                            url: "https://www.sunwing.ca/en/best-vacations",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "2",
                                    title: "All Inclusive Resorts",
                                    "links": [
                                        {
                                            id: "f2-item-0",
                                            title: "Antigua resorts",
                                            url: "https://www.sunwing.ca/en/destinations/antigua",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-1",
                                            title: "Aruba resorts",
                                            url: "https://www.sunwing.ca/en/destinations/aruba",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-2",
                                            title: "Bahamas resorts",
                                            url: "https://www.sunwing.ca/en/destinations/bahamas",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-3",
                                            title: "Costa Rica resorts",
                                            url: "https://www.sunwing.ca/en/destinations/costa-rica",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-4",
                                            title: "Cuba resorts",
                                            url: "https://www.sunwing.ca/en/destinations/cuba",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-5",
                                            title: "Dominican Republic resorts",
                                            url: "https://www.sunwing.ca/en/destinations/dominican-republic",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-6",
                                            title: "Grenada resorts",
                                            url: "https://www.sunwing.ca/en/destinations/grenada",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-7",
                                            title: "Honduras resorts",
                                            url: "https://www.sunwing.ca/en/destinations/honduras",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-8",
                                            title: "Jamaica resorts",
                                            url: "https://www.sunwing.ca/en/destinations/jamaica",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-9",
                                            title: "Mexico resorts",
                                            url: "https://www.sunwing.ca/en/destinations/mexico",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-10",
                                            title: "Panama resorts",
                                            url: "https://www.sunwing.ca/en/destinations/panama",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-11",
                                            title: "Saint Lucia resorts",
                                            url: "https://www.sunwing.ca/en/destinations/saint-lucia",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-12",
                                            title: "St. Maarten resorts",
                                            url: "https://www.sunwing.ca/en/destinations/st-maarten",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "3",
                                    title: "Sunwing Airlines",
                                    "links": [
                                        {
                                            id: "f3-item-0",
                                            title: "About Sunwing Airlines",
                                            url: "https://sunwing.ca/en/sunwing-airlines",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-1",
                                            title: "Airport and web check-in",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/airport-and-web-check-in",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-2",
                                            title: "Flight status and alerts",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/flight-status-alerts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-3",
                                            title: "Baggage allowance",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/baggage-info",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-4",
                                            title: "Seat selection",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/seat-selection",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-5",
                                            title: "Special assistance ",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/special-assistance",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-6",
                                            title: "Accessibility plan",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/accessibility-plan",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-7",
                                            title: "In-flight service",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/inflight-service",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-8",
                                            title: "Passenger rights",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/passenger-care",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-9",
                                            title: "Conditions of carriage and tariffs",
                                            url: "https://www.sunwing.ca/en/sunwing-airlines/conditions-of-contract",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-10",
                                            title: "Optional services",
                                            url: "https://www.sunwing.ca/en/optional-services-sunwing-airlines",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "4",
                                    title: "Corporate",
                                    "links": [
                                        {
                                            id: "f4-item-0",
                                            title: "About us",
                                            url: "https://www.sunwing.ca/en/about-us",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-1",
                                            title: "Contact us",
                                            url: "https://www.sunwing.ca/en/contact-us",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-2",
                                            title: "Careers",
                                            url: "https://jobs.jobvite.com/sunwing/",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-3",
                                            title: "Privacy policy",
                                            url: "https://www.sunwing.ca/en/privacy-policy",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-4",
                                            title: "Terms and conditions",
                                            url: "https://www.sunwing.ca/en/terms-and-conditions",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "5",
                                    title: "Useful links",
                                    "links": [
                                        {
                                            id: "f5-item-0",
                                            title: "FAQs",
                                            url: "https://www.sunwing.ca/en/faqs",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-1",
                                            title: "Travel advisory",
                                            url: "https://www.sunwing.ca/en/promotion/packages/important-travel-advisories",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-2",
                                            title: "Protect your vacation",
                                            url: "https://www.sunwing.ca/en/be-worry-free",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-3",
                                            title: "Price drop guarantee",
                                            url: "https://www.sunwing.ca/en/pricedropguarantee",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-4",
                                            title: "Buy now, pay later",
                                            url: "https://www.sunwing.ca/en/uplift",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-5",
                                            title: "Sunwing gift cards",
                                            url: "https://www.sunwing.ca/en/gift-cards",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-6",
                                            title: "Entry requirements",
                                            url: "https://www.sunwing.ca/en/travel-requirements",
                                            target: "_blank"
                                        }
                                    ]
                                }
                            ]
                        }
                        copyrightText="Copyright © 2026 Sunwing Vacations Inc. TICO #50026548 | Consumer Protection BC #84473 | Quebec O.P.C. #703613"
                        corps={[
                            {
                                id: "Tico",
                                "image": {
                                    "alt": "Tico Logo",
                                    url: "https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/v1613585512/Dev/Footer/tico.png"
                                },
                                "link": {
                                    target: "_blank",
                                    url: "https://www.tico.ca/"
                                }
                            }
                        ]}

                        labels={{
                            ourSite: "Our site"
                        }}
                        lang="en"
                    /> :
                    <Footer
                        data-testid="app-footer"
                        columns={
                            [
                                {
                                    id: "0",
                                    title: "Aubaines de vacances",
                                    "links": [
                                        {
                                            id: "f0-item-0",
                                            title: "Vacances de dernière minute",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/last-minute-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-1",
                                            title: "Forfaits vacances tout compris",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/all-inclusive-vacation-packages",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-2",
                                            title: "Choix du personnel",
                                            url: "https://www.sunwing.ca/fr/vacation-packages/deals/staff-picks",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-3",
                                            title: "Hôtels branchés",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/hot-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-4",
                                            title: "Cuba à moins de 999 $",
                                            url: "https://www.sunwing.ca/fr/all-inclusive-cuba-vacations-under-1000-dollars",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f0-item-5",
                                            title: "Cancún vous attend",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/cancun-is-calling",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "1",
                                    title: "Collections Sunwing",
                                    "links": [
                                        {
                                            id: "f1-item-0",
                                            title: "Exclusivités Sunwing",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/exclusives",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-1",
                                            title: "Viva Fit",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/viva-fit",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-2",
                                            title: "Coups de cœur Sunwing",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/sunwing-favourites",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-3",
                                            title: "Meilleurs hôtels pour adultes",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/adult-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-4",
                                            title: "Hôtels de luxe les mieux cotés",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/luxury-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-5",
                                            title: "Hôtels familiaux les mieux cotés",
                                            url: "https://sunwing.ca/fr/promotion/packages/family-vacations",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-6",
                                            title: "Hôtels Smile - Les enfants séjournent GRATUITEMENT",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/smile-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-7",
                                            title: "Hôtels-boutiques",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/boutique-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-8",
                                            title: "SplashWorld",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/splashworld-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-9",
                                            title: "Familles de 5 personnes",
                                            url: "https://www.sunwing.ca/fr/best-vacations/best-all-inclusive-resorts-for-families",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-10",
                                            title: "RIU-topia",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/riu-topia",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-11",
                                            title: "Collection osée",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/clothing-optional-hotels",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-12",
                                            title: "Des vacances sous le soleil ouvertes à tous",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/2slgbtq-friendly-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-13",
                                            title: "Collection écoresponsable",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/eco-friendly-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-14",
                                            title: "Collection comme dans une émission de téléréalité",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/reality-tv-resorts",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f1-item-15",
                                            title: "Palmarès des meilleurs",
                                            url: "https://www.sunwing.ca/fr/best-vacations",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "2",
                                    title: "Hôtels tout compris",
                                    "links": [
                                        {
                                            id: "f2-item-0",
                                            title: "Hôtels à Antigua",
                                            url: "https://www.sunwing.ca/fr/destinations/antigua",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-1",
                                            title: "Hôtels à Aruba",
                                            url: "https://www.sunwing.ca/fr/destinations/aruba",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-2",
                                            title: "Hôtels aux Bahamas",
                                            url: "https://www.sunwing.ca/fr/destinations/bahamas",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-3",
                                            title: "Hôtels au Costa Rica",
                                            url: "https://www.sunwing.ca/fr/destinations/costa-rica",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-4",
                                            title: "Hôtels à Cuba",
                                            url: "https://www.sunwing.ca/fr/destinations/cuba",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-5",
                                            title: "Hôtels en République dominicaine",
                                            url: "https://www.sunwing.ca/fr/destinations/republique-dominicaine",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-6",
                                            title: "Hôtels à la Grenade",
                                            url: "https://www.sunwing.ca/fr/destinations/grenade",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-7",
                                            title: "Hôtel au Honduras",
                                            url: "https://www.sunwing.ca/fr/destinations/honduras",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-8",
                                            title: "Hôtels en Jamaïque",
                                            url: "https://www.sunwing.ca/fr/destinations/jamaique",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-9",
                                            title: "Hôtels au Mexique",
                                            url: "https://www.sunwing.ca/fr/destinations/mexique",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-10",
                                            title: "Hôtels au Panama",
                                            url: "https://www.sunwing.ca/fr/destinations/panama",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-11",
                                            title: "Hôtels à Sainte-Lucie",
                                            url: "https://www.sunwing.ca/fr/destinations/sainte-lucie",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f2-item-12",
                                            title: "Hôtels à Saint-Martin",
                                            url: "https://www.sunwing.ca/fr/destinations/st-maarten",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "3",
                                    title: "Sunwing Airlines",
                                    "links": [
                                        {
                                            id: "f3-item-0",
                                            title: "À propos de Sunwing Airlines",
                                            url: "https://sunwing.ca/fr/sunwing-airlines",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-1",
                                            title: "Enregistrement à l’aéroport et en ligne",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/airport-and-web-check-in",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-2",
                                            title: "Statut de vol et alertes",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/statut-de-vol-et-alertes",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-3",
                                            title: "Franchise de bagages",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/baggage-info",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-4",
                                            title: "Sélection de sièges",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/seat-selection",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-5",
                                            title: "Assistance spéciale",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/special-assistance",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-6",
                                            title: "Plan sur l’accessibilité",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/accessibility-plan",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-7",
                                            title: "Service en vol",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/inflight-service",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-8",
                                            title: "Droits des passagers",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/passenger-care",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-9",
                                            title: "Modalités de transport et tarifs",
                                            url: "https://www.sunwing.ca/fr/sunwing-airlines/conditions-of-contract",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f3-item-10",
                                            title: "Services facultatifs",
                                            url: "https://www.sunwing.ca/fr/optional-services-sunwing-airlines",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "4",
                                    title: "Corporatif",
                                    "links": [
                                        {
                                            id: "f4-item-0",
                                            title: "À propos de nous",
                                            url: "https://www.sunwing.ca/fr/about-us",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-1",
                                            title: "Communiquer avec nous",
                                            url: "https://www.sunwing.ca/fr/contact-us",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-2",
                                            title: "Carrières",
                                            url: "https://jobs.jobvite.com/sunwing-fr/jobs",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-3",
                                            title: "Politique de confidentialité",
                                            url: "https://www.sunwing.ca/fr/privacy-policy",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f4-item-4",
                                            title: "Modalités et conditions",
                                            url: "https://www.sunwing.ca/fr/terms-and-conditions",
                                            target: "_blank"
                                        }
                                    ]
                                },
                                {
                                    id: "5",
                                    title: "Liens pratiques",
                                    "links": [
                                        {
                                            id: "f5-item-0",
                                            title: "FAQ Service à la clientèle",
                                            url: "https://www.sunwing.ca/fr/faqs",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-1",
                                            title: "Avis aux voyageurs",
                                            url: "https://www.sunwing.ca/fr/promotion/packages/important-travel-advisories",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-2",
                                            title: "Protégez votre voyage",
                                            url: "https://www.sunwing.ca/fr/be-worry-free",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-3",
                                            title: "Garantie de protection de prix",
                                            url: "https://www.sunwing.ca/fr/garantiedeprotectiondeprix",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-4",
                                            title: "Achetez maintenant, payez plus tard",
                                            url: "https://www.sunwing.ca/fr/uplift",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-5",
                                            title: "Cartes-cadeaux Sunwing",
                                            url: "https://www.sunwing.ca/fr/cartes-cadeaux",
                                            target: "_blank"
                                        },
                                        {
                                            id: "f5-item-6",
                                            title: "Exigences d’entrée",
                                            url: "https://www.sunwing.ca/fr/travel-requirements",
                                            target: "_blank"
                                        }
                                    ]
                                }
                            ]
                        }
                        copyrightText="Droit d'auteur © 2026 Vacances Sunwing Inc. TICO no 50026548 | Consumer Protection BC no 84473 | OPC Québec no 703613"
                        corps={[
                            {
                                id: "Tico",
                                "image": {
                                    "alt": "Tico Logo",
                                    url: "https://assets.sunwingtravelgroup.com/image/upload/f_auto,q_auto/v1613585512/Dev/Footer/tico.png"
                                },
                                "link": {
                                    target: "_blank",
                                    url: "https://www.tico.ca/"
                                }
                            }
                        ]}

                        labels={{
                            ourSite: "Our site"
                        }}
                        lang="en"
                    />


                }


            </div>
        );

    }
};

export default AppFooter;